<div class="position-relative district-autocomplete">
  <div class="input-group">
    <input
      #searchInput
      type="text"
      class="form-control border-end-0"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [(ngModel)]="searchText"
      (ngModelChange)="onInputChange()"
      (focus)="onFocus()"
      (blur)="handleBlur()"
      autocomplete="off"
      />
    <span class="input-group-text bg-white border-start-0" (click)="toggleOpen()">
      @if (loading) {
        <span class="spinner-border spinner-border-sm" role="status"></span>
      } @else {
        <i class="bi bi-caret-down-fill" [class.rotated]="open"></i>
      }
    </span>
  </div>

  @if (open) {
    <div class="dropdown-menu show w-100" style="margin-top: -1px;">
      @for (item of suggestions; track trackByDistrictId($index, item)) {
        <button
          type="button"
          class="dropdown-item"
          (click)="selectDistrict(item)"
          >
          <span class="fw-semibold">{{ item.code }}</span>
          <span class="text-body-secondary"> - {{ item.title }}</span>
        </button>
      }
    </div>
  }
</div>
